import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '../../services/AnalyticsService/ListeningDimensions';

export var WidgetPieChart: Widget = {
    type: 'pieChart',
    id: 'pie-chart',
    name: 'Pie Chart',
    useGlobalTimePeriod: true,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 10,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.topicName },
                    INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                    BENCHMARKING: { dimensionName: 'BENCHMARKING_ACCOUNT_ID' },
                    PAID: { dimensionName: 'accountIds' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'RDB_DATA_SOURCE' },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }],
            includeTotal: false,
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Pie Chart',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        legendWrap: true,
        labelLineSpace: 3,
        smartLegendHeader: true,
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        portrait: {
            widgetOrientation: 'portrait',
            zoom: 65,
            legendWidth: 100,
            innerRadiusSize: 18,
            totalValueSize: 40,
            showCustomLabel: false,
            showCustomRatio: false,
            minWedgeRatio: 3,
            minLabelRatio: 3,
            diameterPaddingRatio: 0.2,
            labelRadiusRatio: 0.56,
            legendValueSize: 35,
            legendPercentageSize: 35,
            legendOrientation: 'bottom',
        },
    },
};
